import React from 'react'
import { Flex, Progress } from 'antd';

const WordsByScore = ({ topWords }) => {
  return (
    <div className="shadow-custom rounded-3xl p-5 w-full lg:w-1/2">
      <p className='text-base font-semibold text-black mb-6'>Top Words By Score</p>
      <Flex vertical className="mt-8 gap-7">
        {Object.entries(topWords)?.map(([key, value]) => (
          <div className='flex flex-row justify-between gap-3' key={key}>
            <div className='w-24 text-sm capitalize'>{key}</div>
            <Progress
              style={{ display: Flex, width: "100%" }}
              percent={value}
              size={["100%", 17]}
              strokeColor="#57A43F"
            />
          </div>
        ))}
      </Flex>
    </div>
  )
}

export default WordsByScore